import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useState, useEffect } from "react";

export default function BasicModal(props) {
  const [open, setOpen] = useState(false);
  const { type } = props;
  const handleClose = () => {
    setOpen(false);
    props.handleClose();
  };

  useEffect(() => {
    if (props.showModal) {
      setOpen(true);
    }
  }, [setOpen, props.showModal]);

  const textProvider = (type) => {
    let text = "";
    if (type === "hakuohjeet") {
      text = (
        <p>
          Henkikirjahaun hakutoiminto on kirjainkokoriippumaton eli ei ole väliä
          onko hakutermi kirjoitettu isolla vai pienellä alkukirjaimella.
          Hakutermin alussa ja lopussa voi käyttää katkaisumerkkinä toimivaa
          asteriskia eli tähtimerkkiä (*), joka korvaa yhden tai useamman
          kirjaimen. Esimerkiksi haku termillä <i>Huovi*</i> palauttaa sukunimet{" "}
          <i>Huovila</i> ja <i>Huovinen</i>. Hakutermi <i>*nen</i> puolestaan
          palauttaa kaikki <i>nen</i>-päätteiset sukunimet. Katkaisumerkkiä ei
          voi käyttää vuosiluvuissa.<br></br>
          <br></br>
          Hakuja tehdessä on syytä huomioida, että henkikirjahakuun henkilöiden
          etunimet, patronyymit ja sukunimet on kirjattu lähdeuskollisesti eli
          ne on indeksoitu siinä muodossa kuin ne esiintyvät alkuperäisissä
          henkikirjoissa. Muut tiedot, kuten paikannimet, on normalisoitu
          nykykirjoitusasuun.<br></br>
          <br></br>Henkikirjahaussa hakeminen on mahdollista yhdellä tai
          useammalla hakuehdolla. Kaikki hakuehdot saa näkyviin klikkaamalla
          painiketta <i>Lisää hakuehtoja</i>. Painike <i>Tyhjennä</i> poistaa
          kaikki hakulomakkeeseen kirjatut ehdot uutta hakua varten.<br></br>
          <br></br> Hakutuloksissa yhden henkilön kaikki tiedot saa näkyviin
          kilkkamalla haluttua riviä. Tuloksia on mahdollista järjestää
          esimerkiksi aakkosjärjestykseen tai vuoden mukaan nousevaan tai
          laskevaan järjestykseen. Hakutuloksen linkki klikkaamalla pääsee
          katselemaan digitoitua henkikirjan sivua Kansallisarkiston Astia-
          palvelussa.
        </p>
      );
    } else if (type === "täydentäminen") {
      text = (
        <p>
          Henkikirjahaun täydentäminen perustuu vapaaehtoiseen indeksointiin,
          johon voi osallistua kuka tahansa. Henkikirjojen indeksoinnista
          järjestetään säännöllisesti infotilaisuuksia. Lisää tietoja
          Henkikirjahaun täydentämisestä löydät osoitteesta{" "}
          <a href="https://www.genealogia.fi/henkikirjahaku/">
            www.genealogia.fi/henkikirjahaku
          </a>
          .
        </p>
      );
    } else if (type === "tietokanta") {
      text = (
        <p>
          Henkikirjahaku on Suomen Sukututkimusseuran verkkopalvelu, jossa
          voidaan tehdä hakuja indeksoitujen henkikirjojen sisältöihin
          esimerkiksi henkilöiden ja paikkojen nimillä. Palvelulla pyritään
          edistämään ja helpottamaan henkikirjojen käyttöä sukututkimuksessa.
          Henkikirjoja voidaan käyttää myös korvaavana lähteenä tuhoutuneille
          kirkonkirjoille. Henkikirjahaun kehittämistä ovat tukeneet Karjalan
          Kulttuurirahasto, Waldemar von Frenckells stiftelse ja Föreningen
          Konstsamfundet.<br></br>
          <br></br>
          Henkikirjahaun versio 1.0 (29.3.2023) on toteutettu MVP-tuotteena
          (Minimum Viable Product) eli varhaisen käyttäjän vähimmäisvaatimukset
          täyttävänä verkkopalveluna ja sen kehittämistä jatketaan. Palautetta
          ja kehitysideoita voi lähettää Seuran verkkopalveluasiantuntija Mikko
          Kuitulalle osoitteella etunimi.sukunimi@genealogia.fi.
        </p>
      );
    }
    return text;
  };

  if (!open) {
    return null;
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle variant="h4" component="h2" sx={{ pr: 7 }}>
        {type.charAt(0).toUpperCase() + type.slice(1)}
      </DialogTitle>
      <IconButton
        aria-label="Sulje"
        onClick={handleClose}
        sx={{ position: "absolute", right: 12, top: 14 }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Typography component="div" variant="body1" sx={{ lineHeight: 1.7 }}>
          {textProvider(type)}
        </Typography>
      </DialogContent>
    </Dialog>
  );
}
